// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"239":"a39251bd","732":"5ae15122","977":"bd0a38e0"}[chunkId] + ".chunk.js";
};